/**
 * Returns a string pluralized appropriately based on a number value
 */
export function pluralize(value: number, singularLabel: string): string {
    if (value === 1) {
        return singularLabel
    }

    return `${singularLabel}s`
}
